module.exports = __webpack_public_path__ + "img/yllzb.bee3acdd.jpg";